import React from 'react';
import PresetRequestsPage from './PresetRequestsPage';

const ApprovedRequestsPage = () => <PresetRequestsPage forcedPresetKey="approved" />;

export default ApprovedRequestsPage;
